import * as Sentry from "@sentry/browser";
import { logger } from "./logger";

export function logException(
  error: Error,
  state: string,
  reportEnabled: boolean,
  deviceInfo?: any
) {
  if (reportEnabled) {
    Sentry.captureException(error, {
      extra: {
        state: state,
        deviceInfo,
        context: error.message,
        errorStack: error,
      },
    });
  } else {
    logger.warn("Local development: Sentry reporting is skipped");
  }
}

function initSentry(sentryConfig: {
  dsn: string;
  environment: string;
  debug: boolean;
}) {
  logger.info("Initialized sentry ENV:" + sentryConfig.environment);
  Sentry.init(sentryConfig);
}

export { initSentry };